var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',[_c('BackButton',{attrs:{"to":_vm.__('subscriptions.bundles'),"href":_vm.$route('subscriptions.bundles')}})],1),_vm._v(" "),_c('div',{staticClass:"card card-body"},[_c('pre',[_vm._v(_vm._s(_vm.bundle))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }